import { h, defineComponent, VNode } from 'vue';
// @ts-ignore
import { BNavbarItem } from 'buefy/dist/esm/navbar';
import { t } from '@/ui/i18n/i18n';

export const NavbarHomeItem = defineComponent({
  name: 'NavbarHomeItem',
  setup() {
    return function render(): VNode {
      return h(
        BNavbarItem,
        {
          props: { tag: 'router-link' },
          attrs: {
            to: { name: 'home' },
            exact: true,
          },
        },
        [
          h('img', {
            attrs: { src: '/logo.svg' },
            class: 'navbar__logo',
          }),
          t('common.home'),
        ],
      );
    };
  },
});
